import React,{useState,useRef, useEffect} from 'react';
import Modal from 'react-modal';
import styled from "styled-components";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Zoom } from 'swiper/modules';
import Button from '@mui/material/Button';
import Slider from '@mui/material/Slider';
import HorizontalRuleOutlinedIcon from '@mui/icons-material/HorizontalRuleOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import '@/app/style/photos.scss';

import 'swiper/css';
import 'swiper/css/zoom';
import { useMyContext } from '@/app/utils/MyContext';
import PhotoCaption from "./photoCaption";
import { useBodyScrollLock } from "@/app/utils/Common";
const CloseButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 24px 12px 0px 12px;
  gap: 10px;

  width: 100%;
  height: 48px;
  background-color:black;

  img
  {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
`;

const PhotoContainer = styled.div`
  height: 700px;
  width: 100%;
  background-color: #333333;
  overflow: hidden;
`;

const PhotoDiv = styled.div`
  height: 620px;
  width: 100%;
  background-color: #333333;
  position: relative;
}
`;
const PhotoZoom = styled.div`
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #212121;
  overflow: hidden;
  border-radius: 8px;
  margin: 12px 14px;
`;


const ZoomBtn=styled(Button)`
    background-color: #212121;
    border-radius: 0;
    height: 24px;
    min-width:24px;
    width:24px;
    margin:0 8px;
    box-shadow:none!important;
    &:hover{
        background-color: #212121;
    }
    &:focus{
        boxShadow: 0 0 0 0.2rem rgba(0,123,255,.5)
    }

    &.Mui-disabled{
      opacity: 0.4;
      background-color: #212121;
      color: white;
  }
`
const ZoomSlider=styled(Slider)`
    padding: 2px 0;
    width: 168px;
    border-radius: 8px;
    & .MuiSlider-track{
        background-color:white;
        border: 1px solid white;
    }
    & .airbnb-bar{
        background-color:white;
    }
    & .MuiSlider-rail{
        background-color:white;
    }
    & .MuiSlider-thumb{
        background-color:#fff;
        height: 10px;
        width: 10px;
        &:before{
            box-shadow:none!important;
        }
        &:hover{
            box-shadow:none!important;
        } 
        &:after{
            box-shadow:none!important;
            height:0px;
            width:0px;
        }
    }
    &:focus{
        box-shadow:none!important;
    }
    &:hover{
        box-shadow:none!important;
    } 
    &:before{
        box-shadow:none!important;
    }
    & .Mui-active{
        box-shadow:none!important;
    }
`

const customStyles = {
  content: {
    width: "100%",
    height: "100%",
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    marginRight: '0',
    padding: '0'
  },
  overlay : {
    zIndex: 160
  }
};

const PhotoDivMobile = styled.div`
  height: calc(100% - 48px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: 100%;
  border-radius: 0px;
  background-color:black;

  img
  {
    height: initial;
    width: initial;
    max-width: 100%;
    max-height: 100%;
    border-radius: 0px;
  }
`;

const SinglePhotoWithZoom: React.FC<any> = (props: any) => {
  const {state:myContextState} = useMyContext();
  const {data, type, isSpeedMap, isOpen, onRequestClose} = props;
  const [sliderValue,setSliderValue]=useState(100);
  const divRef = useRef(null);
  const [divWidth, setDivWidth] = useState(1724);
  const divHeight = 620;

  const imgOriginalWidth = isSpeedMap ? data?.width?.value : data?.singlePhoto?.width;
  const imgOriginalHeight = isSpeedMap ? data?.height?.value : data?.singlePhoto?.height;
  const url = isSpeedMap ? data?.url : data?.singlePhoto?.src;

  const title = isSpeedMap ? "" : data?.captionTitle?.value;
  const content = isSpeedMap ? "" : data?.captionContent?.value;

  //test img
  // const url = "/raceInfo.png";
  // const imgOriginalWidth = 900;
  // const imgOriginalHeight = 600;

  // const title = isSpeedMap ? "" : "captionTitle captionTitle captionTitle captionTitle captionTitle captionTitle ";
  // const content = isSpeedMap ? "" : "captionContent captionContent captionContent captionContent captionContent captionContent captionContent captionContent captionContent captionContent captionContent captionContent captionContent captionContent captionContent captionContent captionContent captionContent captionContent captionContent ";

  const [imgWidth, setImgWidth] = useState(imgOriginalWidth);
  const [imgHeight, setImgHeight] = useState(imgOriginalHeight);

  useEffect(() => {  

    const handleWindowResize = () => 
    {
      if ((divRef as any)?.current) {
        const dWidth = (divRef as any)?.current?.offsetWidth;   
        if(dWidth && dWidth > 0)
        {
          setDivWidth(dWidth);
          if(imgOriginalWidth>dWidth || imgOriginalHeight>divHeight)
          {
            const factor = calculateScaleFactor(imgOriginalWidth,imgOriginalHeight,dWidth,divHeight);
            setImgWidth(imgOriginalWidth * factor);
            setImgHeight(imgOriginalHeight * factor);

            console.log(factor, 'factor');
          }
        }
      }
    }
    handleWindowResize();

    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, [data]);

  const calculateScaleFactor = (originalWidth:any,originalHeight:any, targetWidth:any,targetHeight:any) => {
    const widthRatio = targetWidth / originalWidth;
    const heightRatio = targetHeight / originalHeight;
    const newScaleFactor = Math.min(widthRatio, heightRatio);
    return newScaleFactor;
  };

  const hasBrowserScrollbar = () => {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.match(/safari/i) && !ua.match(/chrome/i)) {
      return false;
    } else {
      return true;
    }
  }


  var divPhoto = document.getElementById("divPhoto");
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          var divCaption = document.getElementById("divCaption");
          if(divCaption)
          {
            const divElement = divPhoto as HTMLDivElement;
            const hasVerticalScrollbar = divElement.scrollHeight - divElement.clientHeight > 15;
            const hasHorizontalScrollbar = divElement.scrollWidth - divElement.clientWidth > 15;
            if(hasVerticalScrollbar)
            {
              divCaption.style.width = "calc(100% - 15px)";
            }else{
              divCaption.style.width = "100%";
            }
            if(hasHorizontalScrollbar)
            {
              divCaption.style.bottom = "95px";
            }else{
              divCaption.style.bottom = "80px";
            } 
          }
          
        }
    });
  });

  if(hasBrowserScrollbar() && divPhoto && !isSpeedMap && (title||content))
  {
    observer.observe(divPhoto, { attributes: true, childList: true, subtree: true });
  }
  

  const handleSliderChange = (value: number) => {            
    setSliderValue(value);
  };

  const handleScale=(flag:string)=>{
    if(flag=='+'){
      setSliderValue(sliderValue+50);
    }
    else if(flag=='-'){
      setSliderValue(sliderValue-50);
    }
  }
  useBodyScrollLock(isOpen);
  return (
    type==="pc" ?
    <PhotoContainer>
      <div>
        <PhotoDiv id="divPhoto" ref={divRef} style={{paddingTop:`${divHeight - imgHeight*sliderValue/100>0 ? (divHeight - imgHeight*sliderValue/100)/2 : 0}px`, paddingLeft:`${divWidth - imgWidth*sliderValue/100>0?(divWidth - imgWidth*sliderValue/100)/2 : 0}px`, overflow: `${sliderValue == 100  ? 'hidden' : 'auto'}` }}>
          <img style={{'width':`${imgWidth * sliderValue/100}px`, 'height':`${imgHeight * sliderValue/100}px`}} id='img_speedmap_photo' src={url}></img>
        </PhotoDiv>
        <div id="divCaption" style={{position: "absolute", bottom: "80px", width: "calc(100% - 0px)"}}>
          {isSpeedMap ? <></> : <PhotoCaption title={title} content={content} isDesktop={type==="pc"} index={0}></PhotoCaption>}
        </div>
      </div>  
      <PhotoZoom>
          <ZoomBtn variant="contained" size="small" disabled={sliderValue==100} onClick={()=>handleScale('-')}>
              <HorizontalRuleOutlinedIcon />
          </ZoomBtn>
          <ZoomSlider
              onChangeCommitted={(event: React.SyntheticEvent | Event, value: number | Array<number>)=>{handleSliderChange(value as number)}}
              step={50}
              min={100}
              max={300}
              value={sliderValue}
          />
          <ZoomBtn variant="contained" size="small"  disabled={sliderValue==300} onClick={()=>handleScale('+')}>
              <AddOutlinedIcon />
          </ZoomBtn>
      </PhotoZoom> 
    </PhotoContainer> 
    :
      <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      ariaHideApp={false}
      contentLabel="">
      <CloseButtonDiv>
        <img onClick={onRequestClose} src={`${myContextState.assetPrefix}/commonImg/close.svg`}></img>
      </CloseButtonDiv>
      <PhotoDivMobile>
        <img src={url}></img>
        {isSpeedMap ? <></> : <PhotoCaption title={title} content={content} isDesktop={type==="pc"} index={0}></PhotoCaption>}
      </PhotoDivMobile>
    </Modal>
  );
};
 
export default SinglePhotoWithZoom